import { supabase } from "@/integrations/supabase/client";

// Generate a session ID that persists for the browser session
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('analytics_session_id');
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem('analytics_session_id', sessionId);
  }
  return sessionId;
};

interface TrackEventProps {
  eventName: string;
  properties?: Record<string, any>;
}

export const trackEvent = async ({ eventName, properties = {} }: TrackEventProps) => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    
    await supabase.from('analytics_events').insert({
      user_id: user?.id || null,
      event_name: eventName,
      event_properties: properties,
      page_url: window.location.pathname,
      session_id: getSessionId(),
    });
  } catch (error) {
    // Silently fail to not disrupt user experience
    console.error('Analytics tracking error:', error);
  }
};

// Predefined event names for consistency
export const AnalyticsEvents = {
  PAGE_VIEW: 'page_view',
  CATCH_SUBMITTED: 'catch_submitted',
  CATCH_VERIFIED: 'catch_verified',
  USER_SIGNUP: 'user_signup',
  USER_LOGIN: 'user_login',
  PROFILE_UPDATED: 'profile_updated',
  SHARE_CATCH: 'share_catch',
  BULK_UPLOAD: 'bulk_upload',
  LEADERBOARD_VIEW: 'leaderboard_view',
  STATISTICS_VIEW: 'statistics_view',
} as const;
